export const contactData = {
  lead: "Chętnie pomożemy – wybierz odpowiedni kontakt.",
  cards: [
    { title: "Kontakt ogólny", name: "Robert Nowakowski", phone: "+48 609 365 547", email: "kerin@kerin.pl" },
    { title: "Wsparcie techniczne", name: "Zespół techniczny", phone: "-", email: "m.gapinski@gmail.com" }
  ]
};